// extracted by mini-css-extract-plugin
module.exports = {"title":"LandingContentContainer__title","link":"LandingContentContainer__link","linkText":"LandingContentContainer__linkText"};